<!-- Přílohy k vrstvám -->
<template>
  <DetailsWithSwitchContainer
    v-show="layer.hold && hasPins"
    :layer-id="layer.id"
  >
    <template v-slot:switch-holder>
      <slot name="switch-holder"></slot>
    </template>

    <details
      v-bind:open="isLayerOpen(layer.id)"
      @toggle="detailsClicked([$event, 'layer', layer.id])"
      v-resized="resizeHandler()"
    >
      <summary>{{ layer.name }}</summary>

      <button @click="toggleAllSubs" v-show="layerPins.length">
        <span v-if="allSubsOpen">Zavřít</span>
        <span v-else>Otevřít</span> vše
      </button>

      &nbsp;&nbsp;
      <LayerPinsPrintButton :layer-id="layer.id"></LayerPinsPrintButton
      ><span v-if="subLayers">
        |
        <LayerAndSublayersPinsPrintButton
          :layer-id="layer.id"
        ></LayerAndSublayersPinsPrintButton>
      </span>

      <!-- Pins from layer -->
      <details
        v-for="lp in layerPins"
        :key="lp.id"
        v-bind:open="isPinOpen(lp.id)"
        @toggle="detailsClicked([$event, 'pin', lp.id])"
      >
        <summary>
          Pin č.{{ lp.label }}
          <span v-if="lp.title">&nbsp;| {{ lp.title }}</span>
          <button @click="centerMap(lp)" class="toPinBtn">K pinu ></button>
        </summary>
        <img
          v-if="lp.image"
          v-lazy="fileBaseUrl + lp.image"
          v-bind:alt="lp.title"
        />
        <p v-html="lp.text"></p>
        <a v-bind:href="fileBaseUrl + lp.file" v-if="lp.file" target="_blank"
          >Příloha</a
        >&nbsp;
        <a v-bind:href="fileBaseUrl + lp.file2" v-if="lp.file2" target="_blank"
          >Příloha 2</a
        >&nbsp;
        <a v-bind:href="fileBaseUrl + lp.file3" v-if="lp.file3" target="_blank"
          >Příloha 3</a
        >
        <br />

        <div
          n:if="(threads.markersLayered[lp.id].title && threads.markersLayered[lp.id].text_detail) || threads.markersLayered[lp.id].comments.length > 0"
        >
          <button
            @click="toggleLayerPinDetail(threads.markersLayered[lp.id].id)"
          >
            Detail
          </button>

          <i>
            Komentářů: {{ threads.markersLayered[lp.id].comments.length }}
          </i>
        </div>
      </details>

      <!-- Pins from sublayers -->
      <br v-if="subLayers && layerPins.length" />
      <LayerPins
        v-for="subLayerId in subLayers"
        :key="'pin-' + subLayerId"
        :layer="layers.layers[subLayerId]"
        :subLayers="layers.subLayers[subLayerId]"
        :openedPinLayers="openedPinLayers"
        :openedPins="openedPins"
      ></LayerPins>
    </details>
  </DetailsWithSwitchContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { PINS_ATTACHMENTS_URL } from '@/constants/global.js';
import resized from 'vue-resize-directive';
import PinService from '@/services/PinService';
import DetailsWithSwitchContainer from '@/components/sidebar/parts/DetailsWithSwitchContainer.vue';
import LayerPinsPrintButton from '@/components/sidebar/LayerPinsPrintButton.vue';
import LayerAndSublayersPinsPrintButton from '@/components/sidebar/LayerAndSublayersPinsPrintButton.vue';

export default {
  name: 'LayerPins',
  directives: {
    resized
  },
  components: {
    DetailsWithSwitchContainer,
    LayerPinsPrintButton,
    LayerAndSublayersPinsPrintButton
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    subLayers: {
      type: Array
    },
    openedPins: {
      type: Array
    },
    openedPinLayers: {
      type: Array
    }
  },
  data() {
    return {
      hasPins: false,
      fileBaseUrl: PINS_ATTACHMENTS_URL,
      allSubsOpen: false,
      showDetails: false,
      minPinsWidth: 300
    };
  },
  created() {
    let thisReference = this;
    window.toggleLayerPinDetail = function (layerPinId) {
      thisReference.toggleLayerPinDetail(layerPinId);
      thisReference.$wzBus.$emit('event', {
        event: 'click',
        target: 'button-pin-detail'
      });
    };

    window.toggleLayerPinInURL = function (e, layerPinId) {
      thisReference.detailsClicked([e, 'pin', layerPinId]);
    };

    window.supportPin = (pinId, layerId) => {
      thisReference.$wzBus.$emit('event', {
        event: 'click',
        target: 'button-support-pin'
      });

      PinService.voteForPin(pinId, layerId)
        .then((response) => {
          this.$toasted.show('Pin podpořen.', {
            type: 'success',
            position: 'top-right',
            duration: '5000'
          });

          this.threads.markersLayered[pinId].supportersCounter++;
        })
        .catch(() => {});
    };

    window.deletePin = (pinId, layerId) => {
      this.$swal({
        title: 'Pozor!',
        text: 'Tahle akce je nevratná',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Zrušit'
      }).then((result) => {
        if (result.value) {
          PinService.deletePin(pinId, layerId)
            .then((response) => {
              this.$swal.fire({ title: 'Hotovo.', icon: 'success' });

              this.general.infowindow.close();
              const marker = this.threads.markersLayered[pinId];

              this.$store.dispatch('threads/removeGmLayerMarkers', [pinId]);

              this.$store.dispatch('general/setModalOpenStatus', false);
            })
            .catch(() => {});
        }
      });
    };

    window.openEditView = (pinId) => {
      if (this.general.editPinId && this.general.editPinId !== pinId) {
        this.$swal({
          title: 'Pozor! Máte rozpracovaný pin.',
          text: 'Pokračováním ztratíte neuložené změny.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Pokračovat',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Zrušit'
        }).then((result) => {
          if (result.value) {
            document.getElementById('editPin').click();

            setTimeout(() => {
              this.$store.dispatch('general/setEditPinId', pinId);
              this.$store.dispatch('general/setLayoutOption', [
                'editPin',
                true
              ]);
            }, 500);
          }
        });
      } else {
        this.$store.dispatch('general/setEditPinId', pinId);
        this.$store.dispatch('general/setLayoutOption', ['editPin', true]);
      }
    };

    const pinsEl = document.getElementsByClassName('pins')[0];
    if (pinsEl) {
      this.showDetails = pinsEl.offsetWidth > this.minPinsWidth;
    }
  },
  methods: {
    resizeHandler() {
      const pinsEl = document.getElementsByClassName('pins')[0];
      if (pinsEl) {
        this.showDetails = pinsEl.offsetWidth > this.minPinsWidth;
      }
    },
    toggleLayerPinDetail(layerPinId) {
      this.$store.dispatch('general/setOpenedLayeredPinDetailId', layerPinId);
      this.$store.dispatch('general/setModalOpenStatus', true);

      // Open sidebar
      if (
        !JSON.parse(this.$route.params.sidebarRight) &&
        !JSON.parse(this.$route.params.sidebarLeft)
      ) {
        this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', true]);
        this.$store.dispatch('general/setModalOnlyFlag', true);
      } else {
        this.$store.dispatch('general/setModalOnlyFlag', false);
      }

      // Open <details>
      let openPins = JSON.parse(this.$route.params.openPins);
      this.$store.dispatch('general/setOpenPins', JSON.stringify(openPins));
    },

    openDetail(layerPinId) {
      this.$store.dispatch('general/setOpenedLayeredPinDetailId', layerPinId);
      this.$store.dispatch('general/setModalOpenStatus', true);
    },

    centerMap(marker) {
      if (window.outerWidth < 576) {
        let obj = {
          ...this.$route.params
        };

        // @TODO: refactor!
        this.$store.dispatch('general/setLayoutOption', [
          'sidebarRight',
          false
        ]);
        this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', false]);

        obj['sidebarRight'] = false;
        obj['sidebarLeft'] = false;

        if (query.sidebarSize > 80) {
          query.sidebarSize = 50;
        }

        this.$router
          .replace({ name: 'base', params: obj, query })
          .catch((err) => {});
      }

      this.gmaps.map.panTo(marker.getPosition());

      marker.setAnimation(this.gmaps.google.maps.Animation.BOUNCE);
      setTimeout(function () {
        marker.setAnimation(null);
      }, 750);

      let query = {
        ...this.$route.query
      };

      if (query.sidebarSize > 80) {
        query.sidebarSize = 50;
      }

      this.$router.replace({ name: 'base', query }).catch((err) => {});
    },

    getPins() {
      let filtered = this.threads.markersLayered.filter((mark) => {
        return mark && mark.drawingId === this.layer.id;
      });

      if (filtered.length > 0) {
        this.hasPins = true;
      }

      return filtered;
    },
    toggleAllSubs: function () {
      this.layer.pinLayerOpen = true;

      let openStatus = this.allSubsOpen;

      if (openStatus === true) {
        openStatus = false;
      } else {
        openStatus = true;
      }
      this.allSubsOpen = openStatus;

      let obj = {
        ...this.$route.params
      };
      let openPins = JSON.parse(obj['openPins']);

      if (this.layerPins.length > 0) {
        this.layerPins.forEach((lp) => {
          var index = openPins.indexOf(lp.id);

          if (openStatus) {
            if (index == -1) {
              openPins.push(lp.id);
            }
          } else {
            if (index > -1) {
              openPins.splice(index, 1);
            }
          }
        });

        obj['openPins'] = JSON.stringify(openPins);
        this.$router.replace({ name: 'base', params: obj }).catch((err) => {});
      }
    },
    isLayerOpen(layerId) {
      if (this.layer.pinLayerOpen) {
        return true;
      }
      if (this.openedPinLayers) {
        let index = this.openedPinLayers.indexOf(layerId);

        if (index > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isPinOpen(pinId) {
      if (this.openedPins) {
        let index = this.openedPins.indexOf(pinId);
        if (index > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    detailsClicked([event, targetType, targetId]) {
      let openStatus = event.target.getAttribute('open');
      this.$store.dispatch('layers/toggleOpenLayerPinInURL', [
        targetId,
        targetType,
        openStatus
      ]);
    }
  },
  computed: {
    ...mapState(['gmaps', 'threads', 'general', 'layers']),
    ...mapActions([
      'general/setOpenedLayeredPinDetailId',
      'general/setModalOpenStatus',
      'general/setLayoutOption',
      'general/setModalOnlyFlag',
      'layers/toggleOpenLayerPinInURL',
      'general/setEditPinId',
      'threads/removeGmLayerMarkers',
      'threads/removePolylines',
      'general/destroyPinPolyline'
    ]),
    layerPins() {
      return this.getPins();
    }
  }
};
</script>

<style scoped>
.toPinBtn {
  float: right;
}
</style>
